const otsb_collectionAjaxFilters = (config = {}) => ({
  sectionName: config.sectionName || '',
  sectionId: config.sectionId || '',
  loading: false,
  priceInputTimer: null,
  _cache: new Map(),
  _abortController: null,
  _lastUrl: '',
  openFiltersDesktop: true,
  debounce(fn, delay) {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(fn, delay);
  },
  scheduleFilter() {
    this.debounce(() => {
      this.renderFromCurrentState(this.isMobileActive() ? 'mobile' : 'desktop');
    }, 800);
  },

  initCollectionAjaxFilters(el) {
    if (this.sectionName === '') {
      this.sectionName = el.dataset.sectionName;
    }
    if (this.sectionId === '') {
      this.sectionId = el.dataset.sectionId;
    }
    window.addEventListener('popstate', () => {
      this.renderPage(window.location.href, false);
    });
  },

  get desktopForm() {
    return document.querySelector('#FacetFiltersForm');
  },

  get mobileForm() {
    return document.querySelector('#FacetFiltersFormMobile-' + this.sectionId);
  },

  get sortForm() {
    return document.querySelector('#FacetSortForm-' + this.sectionId);
  },

  onDesktopFilterChange(event) {
    if (!event.target) return;
    this.scheduleFilter();
  },

  onSortChange() {
    this.renderFromCurrentState(this.isMobileActive() ? 'mobile' : 'desktop');
  },

  onGridClick(event) {
    const link = event.target.closest('a[data-pagination-link], .pagination a, a[href*="page="]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    event.preventDefault();
    this.renderPage(href);
  },

  goToUrl(url) {
    if (!url) return;
    this.renderPage(url);
  },

  isMobileActive() {
    return window.innerWidth < 990;
  },

  getActiveForm(mode = 'desktop') {
    if (mode === 'mobile' && this.mobileForm) return this.mobileForm;
    return this.desktopForm;
  },

  appendFormData(params, formData) {
    for (const [key, value] of formData.entries()) {
      if (value === '' || value == null) continue;
      params.append(key, value);
    }
  },

  renderFromCurrentState(mode = 'desktop') {
    const params = new URLSearchParams();
    const activeForm = this.getActiveForm(mode);

    if (activeForm) {
      this.appendFormData(params, new FormData(activeForm));
    }

    if (this.sortForm && mode === 'desktop') {
      const sortData = new FormData(this.sortForm);
      const sortValue = sortData.get('sort_by');
      if (sortValue) {
        params.set('sort_by', sortValue);
      }
    }

    const currentUrl = new URL(window.location.href);

    ['q', 'options[prefix]'].forEach((key) => {
      if (!params.has(key) && currentUrl.searchParams.has(key)) {
        currentUrl.searchParams.getAll(key).forEach((value) => {
          params.append(key, value);
        });
      }
    });

    if (currentUrl.searchParams.has('sort_by') && !params.has('sort_by')) {
      params.set('sort_by', currentUrl.searchParams.get('sort_by'));
    }

    const nextUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
    this.renderPage(nextUrl);
  },

  buildSectionUrl(url) {
    const parsedUrl = new URL(url, window.location.origin);
    parsedUrl.searchParams.set('section_id', this.sectionId);
    return parsedUrl.toString();
  },

  async renderPage(url, updateHistory = true) {
    try {
      this.loading = true;

      const response = await fetch(this.buildSectionUrl(url), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // replace
      this.replaceFromResponse(doc, '[data-render-filters]');
      this.replaceFromResponse(doc, '[data-render-sort]');
      this.replaceFromResponse(doc, '[data-render-count]');
      this.replaceFromResponse(doc, '[data-render-applied-filters]');
      this.replaceFromResponse(doc, '[data-render-grid]');
      this.replaceFromResponse(doc, '[data-render-pagination]');

      if (updateHistory) {
        const historyUrl = new URL(url, window.location.origin);
        window.history.pushState({}, '', `${historyUrl.pathname}${historyUrl.search}`);
      }

    } catch (error) {
      console.error('otsb_collectionAjaxFilters:', error);
      window.location.href = url;
    } finally {
      this.loading = false;
    }
  },

  replaceFromResponse(doc, selector) {
    const newEl = doc.querySelector(selector);
    const currentEl = document.querySelector(selector);

    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
    }
  },

  onMobileSubmit(event) {
    this.renderFromCurrentState('mobile');
  },

  clearAllAppliedFilters() {
    const forms = [this.desktopForm, this.mobileForm];

    forms.forEach(form => {
      if (!form) return;
      form.reset();
    });

    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams();

    // chỉ giữ sort_by nếu có trong URL hiện tại
    if (currentUrl.searchParams.has('sort_by')) {
      params.set('sort_by', currentUrl.searchParams.get('sort_by'));
    }

    const nextUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;

    this.renderPage(nextUrl);
  }
});

window.otsb_collectionAjaxFilters = otsb_collectionAjaxFilters;
document.addEventListener('alpine:init', () => {
  Alpine.store('otsb_collectionAjaxFilters', otsb_collectionAjaxFilters());
  Alpine.data('otsb_collectionAjaxFilters', otsb_collectionAjaxFilters);
});

